import {createContext} from 'react'
export const StoreAccountContext = createContext()